export default __webpack_public_path__ + "static/media/solana-icon.b0b5c7aa.svg";